var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [(_vm.showCreateTrip == false) ? _c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true",
      "title": "Search Filter"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Create Trip"
    },
    on: {
      "click": function($event) {
        _vm.showTripMgmt('created')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-2x",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "style": "color: red;"
    }
  })])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Trip ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-card-o' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripid),
      expression: "tripid"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "tripid",
      "id": "tripid",
      "placeholder": "Enter Trip ID"
    },
    domProps: {
      "value": (_vm.tripid)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchTrip()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tripid = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Trip Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gear' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.tripStatuslist,
      "placeholder": "Select Trip Status",
      "append-to-body": true,
      "name": "tripStatus"
    },
    model: {
      value: (_vm.tripStatus),
      callback: function($$v) {
        _vm.tripStatus = $$v
      },
      expression: "tripStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("AWB/Requested Pickup")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWB),
      expression: "AWB"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "AWB",
      "id": "AWB",
      "placeholder": "Enter AWB No/Requested Pickup ID"
    },
    domProps: {
      "value": (_vm.AWB)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchTrip()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWB = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client Short/Display Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.companyNamelist,
      "name": "companyName",
      "placeholder": "Select Client",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true
    },
    model: {
      value: (_vm.companyName),
      callback: function($$v) {
        _vm.companyName = $$v
      },
      expression: "companyName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client Location")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker' style='font-size: 12px'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.ClientLocationList,
      "selected-option": _vm.clientLocationitem,
      "placeholder": "Select Client Location",
      "name": "clientLocation"
    },
    on: {
      "select": _vm.selectedClientLocation
    },
    model: {
      value: (_vm.clientLocation),
      callback: function($$v) {
        _vm.clientLocation = $$v
      },
      expression: "clientLocation"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Assigned BA/SR")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gear' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "disabled": _vm.disabledflag == true,
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.AssignedList,
      "placeholder": "Select Assigned BA/SR",
      "append-to-body": true,
      "name": "AssignedSR"
    },
    model: {
      value: (_vm.AssignedSR),
      callback: function($$v) {
        _vm.AssignedSR = $$v
      },
      expression: "AssignedSR"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Trip creation date range ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "range": "",
      "shortcuts": _vm.shortcuts,
      "lang": "en",
      "name": "tripCreationDate",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.tripCreationDate),
      callback: function($$v) {
        _vm.tripCreationDate = $$v
      },
      expression: "tripCreationDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Trip start date range ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripStartDate),
      expression: "tripStartDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "max": _vm.tripEndDate,
      "name": "tripStartDate",
      "not-after": _vm.tripEndDate
    },
    domProps: {
      "value": (_vm.tripStartDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tripStartDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.FromDateErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Trip end date range ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripEndDate),
      expression: "tripEndDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "min": _vm.tripStartDate,
      "name": "tripEndDate",
      "not-before": _vm.tripStartDate
    },
    domProps: {
      "value": (_vm.tripEndDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tripEndDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ToDateErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("MPS")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.MPS),
      expression: "MPS"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "MPS",
      "id": "MPS",
      "placeholder": "Enter MPS"
    },
    domProps: {
      "value": (_vm.MPS)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchTrip()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.MPS = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Assigned To")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignedTo),
      expression: "assignedTo"
    }],
    attrs: {
      "type": "radio",
      "id": "BA",
      "value": "TSP BA",
      "name": "assignedTo"
    },
    domProps: {
      "checked": _vm._q(_vm.assignedTo, "TSP BA")
    },
    on: {
      "__c": function($event) {
        _vm.assignedTo = "TSP BA"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "BA"
    }
  }, [_vm._v("BA ")]), _vm._v("     \n                          "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignedTo),
      expression: "assignedTo"
    }],
    attrs: {
      "type": "radio",
      "id": "SR",
      "value": "SR",
      "name": "assignedTo"
    },
    domProps: {
      "checked": _vm._q(_vm.assignedTo, "SR")
    },
    on: {
      "__c": function($event) {
        _vm.assignedTo = "SR"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "SR"
    }
  }, [_vm._v("SR")]), _vm._v("     \n                        ")])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "7rem"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchTrip
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                          "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])])])])], 1)], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Trip Management List")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.totalCount))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px",
      "margin-left": "6rem"
    }
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.DownloadTrips
    }
  }, [_vm._v("Download .XLSX")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('custom-expandable-table', {
    key: _vm.expandableKey,
    attrs: {
      "columns": _vm.tableColumn,
      "isEditHidden": false,
      "items": _vm.tableItems,
      "innerTableHeader": _vm.innerTableColumn,
      "offset": _vm.offset
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('legend', [_vm._v("Trip Details")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "55%"
    }
  }, [_vm._v("Vehicle Number")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tripDetails.vehiclenumber))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "55%"
    }
  }, [_vm._v("Odo Reading(km)   - Start")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tripDetails.openkm) + ", "), _c('b', [_vm._v("End:")]), _vm._v(" " + _vm._s(_vm.tripDetails.closekm))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "55%"
    }
  }, [_vm._v("Trip Start Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tripDetails.tripstartdate))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "55%"
    }
  }, [_vm._v("Trip End Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tripDetails.tripenddate))])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('legend', [_vm._v(" First Mile Details")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Assigned")]), _vm._v(" "), _c('th', [_vm._v("AWBs:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.awbdetails.fmawb))]), _vm._v(" "), _c('th', [_vm._v("MPS:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.mpsFM.mps_count))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Picked")]), _vm._v(" "), _c('th', [_vm._v("AWBs:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.awbdetails.fmpicked))]), _vm._v(" "), _c('th', [_vm._v("MPS:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.mpsFM.mpspicked))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Not Picked")]), _vm._v(" "), _c('th', [_vm._v("AWBs:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.awbdetails.fmunpicked))]), _vm._v(" "), _c('th', [_vm._v("MPS:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.mpsFM.mpsunpicked))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('legend', [_vm._v(" Last Mile Details")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Assigned")]), _vm._v(" "), _c('th', [_vm._v("AWBs:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.awbdetails.lmawb))]), _vm._v(" "), _c('th', [_vm._v("MPS:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.mpsLM.mps_count))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Delivered")]), _vm._v(" "), _c('th', [_vm._v("AWBs:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.awbdetails.lmdelivered))]), _vm._v(" "), _c('th', [_vm._v("MPS:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.mpsLM.mpsdelivered))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Undelivered")]), _vm._v(" "), _c('th', [_vm._v("AWBs:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.awbdetails.lmundelivered))]), _vm._v(" "), _c('th', [_vm._v("MPS:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.mpsLM.mpsundelivered))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_c('button', {
    staticClass: "btn1 -btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showcreatetrip
    }
  }, [_vm._v("View Trip")])]), _vm._v(" "), _c('label', [_c('button', {
    staticClass: "btn1 btn-success",
    attrs: {
      "type": "reset",
      "disabled": _vm.tripStatus == 'closed' || _vm.tripStatus == 'completed'
    },
    on: {
      "click": function($event) {
        _vm.showStartTrip('starttrip')
      }
    }
  }, [_vm._v("Start Trip")])]), _vm._v(" "), _c('label', [_c('button', {
    staticClass: "btn1 btn-primary",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.showtripsheet
    }
  }, [_vm._v("Trip Sheet")])]), _vm._v(" "), _c('label', {
    staticClass: "cutomtooltip"
  }, [_c('button', {
    staticClass: "btn1 btn-danger",
    staticStyle: {
      "pointer-events": "auto"
    },
    attrs: {
      "type": "Button",
      "disabled": _vm.tripStatus == 'closed' || _vm.tripStatus == 'created' || (_vm.tripDetails.isdth == 1 && _vm.tripDetails.hubid == _vm.defaultHubID)
    },
    on: {
      "click": function($event) {
        _vm.closeTrip('start')
      }
    }
  }, [_vm._v("Close Trip")]), _vm._v(" "), (_vm.tripDetails.isdth == 1 && _vm.tripDetails.hubid == _vm.defaultHubID) ? _c('span', {
    staticClass: "cutomtooltiptext"
  }, [_vm._v(_vm._s(_vm.closeToolMessage))]) : _vm._e()])])]), _vm._v(" "), _c('div', [(_vm.viewTripMgmt) ? _c('tripMgmt-firstLast-miles', {
    attrs: {
      "childtripfm": _vm.parenttripfm,
      "childtriplm": _vm.parenttriplm,
      "pickuprequest": _vm.pickuprequestid,
      "tripid": _vm.podID,
      "trippod": _vm.cargopod
    }
  }) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [(_vm.showCreateTrip == true) ? _c('div', [(_vm.TripType == 'created') ? _c('div', [_c('create-trip-management', {
    attrs: {
      "parentObj": _vm.parentData
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.TripType == 'start') ? _c('div', [_c('close-trip', {
    attrs: {
      "parentObj": _vm.parentData
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.TripType == 'starttrip') ? _c('div', [_c('start-trip', {
    attrs: {
      "parentOBJ": _vm.parentData
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.showGenerateTrip = false
      }
    },
    model: {
      value: (_vm.showGenerateTrip),
      callback: function($$v) {
        _vm.showGenerateTrip = $$v
      },
      expression: "showGenerateTrip"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.loader
    },
    on: {
      "update:active": function($event) {
        _vm.loader = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Trip Sheet")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeGenerateTripSheet
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("Trip ID:")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.tripSheet.tmstripid))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("Vehicle:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tripSheet.vehiclenumber))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "12%"
    }
  }, [_vm._v("Trip Assigned To:")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.tripSheet.usertype))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "12%"
    }
  }, [_vm._v("BA/SR Name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tripSheet.username))])])])]), _vm._v(" "), _c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Vehicle Start ODO reading:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tripSheet.openkm))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("Trip Tags:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tripSheet.isdth == 1 ? 'DTH' : 'Standard'))]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td'), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_c('button', {
    staticClass: "-btn btn-primary1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ShowTripSheetPdf
    }
  }, [_vm._v("Print")])])])])]), _vm._v(" "), _c('div', [(_vm.showTripShipment) ? _c('trip-shipment', {
    attrs: {
      "parentOBJ": _vm.tripSheet
    }
  }) : _vm._e()], 1)])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "xl"
    },
    on: {
      "ok": function($event) {
        _vm.showDTHtostandered = false
      }
    },
    model: {
      value: (_vm.showDTHtostandered),
      callback: function($$v) {
        _vm.showDTHtostandered = $$v
      },
      expression: "showDTHtostandered"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.loader
    },
    on: {
      "update:active": function($event) {
        _vm.loader = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Converting DTH to Standard")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeDTHtostandered
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Reason")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('reason')
    },
    attrs: {
      "name": "reason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Reason")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Controlling hub is choked"
    }
  }, [_vm._v("Controlling hub is choked")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Marked DTH by mistake"
    }
  }, [_vm._v("Marked DTH by mistake")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Others"
    }
  }, [_vm._v("Others")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('reason')),
      expression: "errors.has('reason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('reason')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "25rem"
    }
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Update")])])], 1)])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "xl"
    },
    on: {
      "ok": function($event) {
        _vm.showCloseTripModal = false
      }
    },
    model: {
      value: (_vm.showCloseTripModal),
      callback: function($$v) {
        _vm.showCloseTripModal = $$v
      },
      expression: "showCloseTripModal"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('b-tab', {
    staticClass: "tab-content1 tab-header1"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Pending AWB/Pickup Request Status")]), _vm._v(" "), _c('button', {
    staticClass: "closemodal",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeTripModal
    }
  }, [_vm._v("×")])], 1), _vm._v(" "), _c('fieldset', [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Trip could not be closed because of incomplete AWB/Pickup Request  Status.")]), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newObj.pickuparr.length > 0),
      expression: "newObj.pickuparr.length > 0"
    }]
  }, [_vm._v("Incomplete Pickup Request Status ")]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newObj.pickuparr.length > 0),
      expression: "newObj.pickuparr.length > 0"
    }],
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Pickup Request")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Current Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Comment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.newObj.pickuparr), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.id))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pickuprequeststatus))]), _vm._v(" "), (data.actualweight) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v("Actual picked weight is "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(data.actualweight))]), _vm._v(" KG and Expected Weight is "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(data.expectedweight))]), _vm._v(" KG. Kindly mark it partial pickup or else meet the expected weight requirement.")]) : _c('td', {
      staticClass: "text-center"
    }, [_vm._v("Pickup Request should be picked or unpicked")])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newObj.awb.length > 0),
      expression: "newObj.awb.length > 0"
    }]
  }, [_vm._v("Incomplete AWB Status")]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newObj.awb.length > 0),
      expression: "newObj.awb.length > 0"
    }],
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Current Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Comment")])])]), _vm._v(" "), _c('tbody', _vm._l(((_vm.newObj.awb)), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awbstatus))]), _vm._v(" "), ((_vm.newObj.awb[index].allocationtype) == 'firstmile') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v("Shipment should be picked or unpicked")]) : ((_vm.newObj.awb[index].allocationtype) == 'lastmile') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v("Shipment should be delivered or undelivered")]) : _vm._e()])
  }))])])])], 1), _vm._v(" "), (_vm.showtripsheetpdf) ? _c('trip-sheet-pdf', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "tripsheetdata": _vm.tripsheetdata
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10c83730","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/TripManagement/TripManagementListing/TripManagementListing.component.html
// module id = 1379
// module chunks = 3